import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import { useRef } from "react";

const SearchDataObjects = (props) => {
  const useStyles = makeStyles((theme) => ({
    root: {
      "&.Mui-focused": {
        border: "none",
      },
      display: "flex",
      alignItems: "center",
      marginLeft: "4px",
      marginTop: "13px",
      marginBottom: "13px",
      border: "1px solid #C4C4C4",
      borderRadius: "2px",
      background: "#FFFFFF 0% 0% no-repeat padding-box",
      height: "28px",
      transition: "width 0.5s ease-in-out",
      width: props.width,
    },
    input: {
      "&.Mui-focused": {
        border: "none",
      },
      flex: 1,
      paddingTop: 0,
      paddingBottom: 0,
      textAlign: "left",
      fontSize: "12px",
      lineHeight: "17px",
      fontFamily: "Open Sans",
      letterSpacing: "0px",
      color: "#606060",
      opacity: 1,
    },
    iconButton: {
      padding: 10,
      height: 12,
    },
    divider: {
      height: 28,
      margin: "auto",
    },
  }));

  const classes = useStyles();
  const inputRef = useRef(null);

  return (
    <div>
      <Paper
        ref={inputRef}
        onClick={() => inputRef.current.focus()}
        component="form"
        className={classes.root}
        elevation={0}
      >
        <InputBase
          aria-label={"Search Value"}
          className={classes.input}
          placeholder="Search"
          inputProps={{ "aria-label": "search google maps" }}
          onChange={(e) => props.setQuery(e.target.value)}
          endAdornment={<SearchIcon />}
        />
      </Paper>
    </div>
  );
};

export default SearchDataObjects;
